export default __webpack_public_path__ + "static/bg-spacex--mobile-2158751b88022441cdce5ad8e25357c3.jpg";